export default __webpack_public_path__ + "static/media/dragonspine_spear.a9e18e36.png";